export default __webpack_public_path__ + "static/custom-marker-shapes-89e25a76e681707f4bfc7091540c7601.png";